<a class="d-flex align-items-center pointer mb-4" id="logout-button" (click)="logoutService.logout()">
	<i class="ti ti-logout text-danger fs-4 me-3"></i>
	<span class="text-danger fw-bolder">{{'security.logout' | translate}}</span>
</a>
